import { useEffect, useState } from "react";

const useDataGrid = ({ onParamsChange = () => {} }) => {
  const [requestParams, setRequestParams] = useState({
    currentPage: [["page", 1]],
  });

  useEffect(() => {
    const urlParams = new URLSearchParams();
    

    Object.values(requestParams).map((item) =>
      item.map(([key, value]) => {if(!Array.isArray(key)){urlParams.append(key, value)}else{
        urlParams.append(key[0],key[1])
        urlParams.append(value[0],value[1])
       
      }})
    );
      // urlParams.append
    delete requestParams.currentPage
    // delete requestParams.page
    
    onParamsChange(urlParams);
  }, [requestParams]);

  const handlePaginate = (params) => {
    console.log(params, requestParams)
    setRequestParams((old) => ({
      ...old,
      currentPage: [["page", params.current]],
    }));
  };

  const handleChecks = ({ checks }) => {
    setSelected(checks);
  };

  const handleChangeAmount = ({ value }) => {
    setRequestParams((old) => ({
      ...old,
      currentPage: [["page", 1]],
      amount: [["size", value]],
    }));
  };

  const handleFilter = (filters) => {
    
    setRequestParams((old) => ({
      ...old,
      filters: filters.map(({ query }) => query),
    }));
  };

  return {
    handlePaginate,
    handleChecks,
    handleChangeAmount,
    handleFilter,
    requestParams,
  };
};

export default useDataGrid;
